export default __webpack_public_path__ + "static/media/redo-edit.d5556e48.svg";